const respondToMainCtaVisibility = function (element, callback) {
  const options = {
    rootMargin: '0px',
    threshold: 1,
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const observer = new IntersectionObserver(
    debounce((entries, observer) => {
      entries.forEach((entry) => {
        callback(entry.isIntersecting);
      });
    }, 100),
    options
  );

  observer.observe(element);
};

const toggleStickyCtaVisibility = (isMainCtaVisible) => {
  const stickyCtaContainer = document.querySelector('.sticky-cta-container');

  if (stickyCtaContainer !== null) {
    if (isMainCtaVisible) {
      stickyCtaContainer.classList.add('tw-hidden');
      stickyCtaContainer.classList.remove('tw-flex');
    } else {
      stickyCtaContainer.classList.remove('tw-hidden');
      stickyCtaContainer.classList.add('tw-flex');
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const mainCtaNode = document.querySelector('.jump-product-cta-visibility');

  if (mainCtaNode !== null) {
    respondToMainCtaVisibility(mainCtaNode, toggleStickyCtaVisibility);
  }
});
